import adsApi from '../../../libs/ads-request/ads-api';

async function reviewQuotation(payload) {
  const { data } = await adsApi.reviewQuotation(payload);

  return data.data;
}

export default function createApiQuotationRepository() {
  return {
    reviewQuotation,
  };
}
